import {
  CHANGE_PASSWORD,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_ERROR,
  GET_PASSWORD_HISTORY,
  GET_PASSWORD_HISTORY_SUCCESS,
  GET_PASSWORD_HISTORY_ERROR,
} from "./actionTypes";

const initialState = {
  changeSuccessMsg: null,
  changeError: null,
  passwordHistory: [],
  historyLoading: false,
  historyError: null,
};

const changePassword = (state = initialState, action) => {
  switch (action.type) {
    case CHANGE_PASSWORD:
      state = {
        ...state,
        changeSuccessMsg: null,
        changeError: null,
      };
      break;
    case CHANGE_PASSWORD_SUCCESS:
      state = {
        ...state,
        changeSuccessMsg: action.payload,
        changeError: null,
      };
      break;
    case CHANGE_PASSWORD_ERROR:
      console.log("Change Error:", action.payload.old_password);
      state = { ...state, changeError: action.payload.old_password };
      break;

    // NEW: password change history
    case GET_PASSWORD_HISTORY:
      state = { ...state, historyLoading: true, historyError: null };
      break;
    case GET_PASSWORD_HISTORY_SUCCESS:
      state = {
        ...state,
        historyLoading: false,
        passwordHistory: action.payload,
      };
      break;
    case GET_PASSWORD_HISTORY_ERROR:
      state = { ...state, historyLoading: false, historyError: action.payload };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default changePassword;
